<script>
import { mapGetters } from 'vuex'
import * as Helper from '@/modules/helper/index'
export default {
  computed: {
    ...mapGetters([
      'MainMenuLayout',
      'MainMenuList',
      'MainMenu',
      'DesignSettings',
      'AppURLs',
      'MoreMenuIconURL'
    ])
  },
  methods: {
    getItemStyle(backgroundColor) {
      if (Helper.IsValid(this.MainMenu.MenuItemFontColor)) {
        let hashCodefc = Helper.HashCodeFromInt(this.MainMenu.MenuItemFontColor)
        let hashCodebc = Helper.HashCodeFromInt(backgroundColor)
        let colorrgb = Helper.hexToRgb(hashCodebc)
        return {
          'color': hashCodefc,
          // 'font-family': this.MainMenu.MenuItemFontName,
          'background': 'rgba(' + colorrgb + ',' + this.MainMenu.MenuItemContainerOpacity + ')'
        }
      }
    },
    getMenuStyle() {
      let hashCodebc = Helper.HashCodeFromInt(this.DesignSettings.AppThemeColor)
      let colorrgb = Helper.hexToRgb(hashCodebc)
      if (Helper.IsValid(this.MainMenu.MenuItemFontName)) {
        return {
          'font-family': this.MainMenu.MenuItemFontName,
          'background-color': 'rgba(' + colorrgb + ',' + this.MainMenu.MenuItemContainerOpacity + ')'
        }
      }
    },
    IsNullOrEmpty(value) {
      return Helper.IsNullOrEmpty(value)
    }
  }
}
</script>
<template>
<f7-toolbar bottom-md tabbar labels v-if="MainMenuLayout === 1 && MainMenuList.length !== 0" class="custom-tab-menu" :class="{'tabbar-ios': $theme.ios, 'tabbar-md' : !$theme.ios}" :style="getMenuStyle()">
  <f7-link v-for="(MenuItem,index) in MainMenuList" v-if="index < 3" 
    :href="`/${MenuItem.url}/${MenuItem.Id}`" :key="index" 
    :class="{'label-hide' : IsNullOrEmpty(MenuItem.MenuLabel)}"  
    :style="getItemStyle(MenuItem.MenuIconColor)">
    <img v-if="!IsNullOrEmpty(MenuItem.MenuIcon)" :src="MenuItem.MenuIcon" class="img-margin" />
    <div v-else  class="black-image-space"></div>
    <div v-if="MenuItem.UnreadChatMessageCount && MenuItem.UnreadChatMessageCount > 0" class="badge">{{MenuItem.UnreadChatMessageCount}}</div>
    <span class="tabbar-label">{{MenuItem.MenuLabel}}</span>
  </f7-link>
  <f7-link v-if="MainMenuList.length === 4" :href="`/${MainMenuList[3].url}/${MainMenuList[3].Id}`" :class="{'label-hide' : IsNullOrEmpty(MainMenuList[3].MenuLabel)}" :style="getItemStyle(MainMenuList[3].MenuIconColor)">
    <img v-if="!IsNullOrEmpty(MainMenuList[3].MenuIcon)" :src="MainMenuList[3].MenuIcon" class="img-margin">
    <div v-else class="black-image-space"></div>
    <div v-if="MainMenuList[3].UnreadChatMessageCount && MainMenuList[3].UnreadChatMessageCount > 0" class="badge">{{MainMenuList[3].UnreadChatMessageCount}}</div>
    <span class="tabbar-label" >{{MainMenuList[3].MenuLabel}}</span>
  </f7-link>
  <!-- More Menu Link -->
  <f7-link v-if="MainMenuList.length > 4" popup-open="#more-popup" :class="{'label-hide' : IsNullOrEmpty(MainMenu.MenuItemOverflowLabel)}" :style="getItemStyle(MainMenu.MenuItemOverflowBackgroundColor)">
    <img v-if="!IsNullOrEmpty(MoreMenuIconURL)" :src="MoreMenuIconURL" class="img-margin">
    <div v-else class="black-image-space"></div>
    <span class="tabbar-label">{{MainMenu.MenuItemOverflowLabel}}</span>
  </f7-link>
</f7-toolbar>
</template>
<style scoped>
  .img-margin {
    margin: 4px auto;
  }
  .label-hide .tabbar-label {
    display: none!important;
  }
  /* .badge{
    min-width: 16px;
    height: 16px;
    position: absolute;
    top: 2px;
    left: 51%;
    line-height: 16px;
    padding: 0 5px;
    font-size: 10px;
    max-width: 40px;
    font-family: -apple-system, SF UI Text, Helvetica Neue, Helvetica, Arial, sans-serif;
  }
  .black-image-space + .badge {
    top: 12px;
    z-index: 1;
  } */
</style>



// WEBPACK FOOTER //
// src/components/shared/menu-layout/TabMenu.vue